import axios from "axios";
import { API_URL, authHeader } from "./api";

const ENDPOINT_URL = API_URL + "hotel/";

class HotelService {
  getHotel() {
    return axios.get(`${ENDPOINT_URL}options`, {
      headers: authHeader(),
    });
  }

  updateHotel(hotel) {
    return axios.patch(ENDPOINT_URL, hotel, { headers: authHeader() });
  }

  expectedToOnlineCheckin() {
    return axios.post(
      ENDPOINT_URL + "bookings/expected-to-online-checkin",
      {},
      { headers: authHeader() },
    );
  }

  uploadCover(file) {
    const formData = new FormData();
    formData.append("file", file);
    return axios.post(ENDPOINT_URL + "uploadCover", formData, {
      headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
    });
  }

  uploadEmailHeader(file, { source, design, revision } = {}) {
    const formData = new FormData();
    if (file) formData.append("file", file);
    if (source) formData.append("source", source);
    if (design) {
      formData.append("design", JSON.stringify(design));
      formData.append("revision", String(revision || 0));
    }
    return axios.post(ENDPOINT_URL + "uploadEmailHeader", formData, { headers: authHeader() });
  }

  getEmailHeaderSource() {
    return axios.get(ENDPOINT_URL + "email-header/source", { headers: authHeader(), responseType: "blob" });
  }

  uploadLogo(file) {
    const formData = new FormData();
    formData.append("file", file);
    return axios.post(ENDPOINT_URL + "uploadLogo", formData, {
      headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
    });
  }

  updateWhiteLabelConfig(payload) {
    return axios.put(ENDPOINT_URL + "white-label-config", payload, {
      headers: authHeader(),
    });
  }

  sendWhiteLabelTestEmail(payload) {
    return axios.post(ENDPOINT_URL + "white-label-config/test", payload, {
      headers: authHeader(),
    });
  }

  clearWhiteLabelConfig() {
    return axios.delete(ENDPOINT_URL + "white-label-config", {
      headers: authHeader(),
    });
  }
}

export default new HotelService();
